export const domains = ["social", "generator", "web"] as const;
export type DomainName = (typeof domains)[number];
